import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.welcome_bonus,
    (welcome_bonus) => {
        return welcome_bonus
    }
)